import { URGENCY_TYPES } from '@/models/Transaction'

export default (value) => {
  const types = {
    [URGENCY_TYPES.URGENT]: 'STANDARD',
    [URGENCY_TYPES.EXPRESS]: 'EXPRESS'
  }

  if (types[value] != null) {
    return types[value]
  }

  return value
}
